import React from 'react';
import { Col, Row } from 'antd';

import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';


const SortableItem = SortableElement(({value, moving}) => 
  <Col span={3} className={moving? 'sortable-item-moving sortable-item': 'sortable-item'}>
    <Row type="flex" justify="center">
    {/* {console.log(moving)} */}
      <Col>
        <Row style={{fontWeight: 'bold'}}>{value.title}</Row>
        { value.image? 
            <img alt="sortable-img" className="sortable-image" src={value.image.url} />
          :
          null
          }
      </Col>
    </Row>
  </Col>);

const SortableList = SortableContainer(({banners, moving}, ) => {

  if(banners === null || banners.length<1) {
    return null
  }
  return (
    <Row 
    align="middle"
    justify="center"
    className="sortable-body">
      {banners.map((banner, i) => (
        <SortableItem 
        key={`item-${i}`} 
        moving={moving}
        index={i} 
        value={banner} />
      ))}
    </Row>
  );
});

class SortableComponent extends React.Component {
    render() {

        const { banners } = this.state;
        if(banners.length < 1) {
          return (<span>No banners</span>)
        }

        return(
          <SortableList 
            banners={banners} 
            onSortEnd={this.onSortEnd} 
            onSortMove={this.onSortMove}
            moving={this.state.moving}
            axis='x'
            lockAxis='x'
            pressDelay={100}
            useWindowAsScrollContainer={true}
            lockToContainerEdges={true}
            />
        )
    }
      
    constructor(props) {
      super(props);
      this.state = {
        banners: [],
        moving: false
      }
    }

    componentWillMount() {
      this.setState({
        banners: this.props.banners
      })
    }

    componentWillReceiveProps(newProps) {
      // console.log("new props")
      if(newProps.banners.length !== this.state.banners.length) {
          this.setState({
              banners: newProps.banners
          })
      }
    }

    onSortEnd = ({oldIndex, newIndex}) => {

      let arrangedBanners = arrayMove(this.state.banners, oldIndex, newIndex);

      // console.log("old index = " , oldIndex , " , newIndex = " , newIndex)
      this.setState({
        banners: arrangedBanners,
        moving: false
      });

      this.props.onSortEnd(arrangedBanners)
      // this.setState({
      //   items: arrayMove(this.state.items, oldIndex, newIndex),
      // });
    };

    onSortMove = () => {
      this.setState({
        moving: true
      })
    }

    swapBannerElements = (banners, oldIndex, newIndex) => {

      // const _banners = JSON.parse(JSON.stringify(banners));

      let elementToShift;

      elementToShift = banners.splice(oldIndex, 1);
      banners.splice(newIndex, 0, elementToShift[0]);
      
      
      // console.log("before moving =" , _banners_)
      // const elementsBetweenTwoIndexes = _banners.splice(newIndex, oldIndex - newIndex );
      // console.log("Indexes = old, new = " , oldIndex , " , " , newIndex , ", after moving = " , _banners)
     
      return banners;

      // console.log("newly arranged banners = " , _banners)
    }

}

export default SortableComponent;









// WEBPACK FOOTER //
// ./src/components/banners/sort-banner-card/sortable-component.js